import { Content } from "../../squidex";
const cloneDeep = require('lodash.clonedeep');

export class LanguageModel extends Content {
    constructor(current?: Content) {
      if (current) {
        super(cloneDeep(current) as Content);
        } else {
            super({});
        }
    }
}
